module.exports = __webpack_public_path__ + "img/bottle_outcoming.c0e80289.png";